import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const defaultState: VendorStoreState = {
    accessToken: '',
    expiresIn: '',
    vendorId: '',
    vendorInfo: null,
    vendor: null,
};

export const useVendorStore = create<VendorStoreState & VendorStoreAction>()(
    persist(
        (set) => ({
            ...defaultState,
            reset: () => {
                set(() => ({ ...defaultState }));
            },
            setVendor: (vendor) => {
                set((state) => ({
                    vendor: typeof vendor === 'function' ? vendor(state.vendor) : vendor,
                }));
            },
        }),
        {
            name: 'vendor-storage',
            storage: createJSONStorage(() => sessionStorage),
        },
    ),
);

// 비-React 환경에서 사용할 수 있는 스토어 인스턴스
export const vendorStore = useVendorStore;

export interface VendorStoreState {
    accessToken: string;
    expiresIn: string;
    vendorId: string;
    vendorInfo: any | null;
    vendor: any | null;
}

export interface VendorStoreAction {
    reset: () => void;
    setVendor: (vendor: any) => void;
}
